import {
  required,
  Edit,
  SimpleForm,
  useNotify,
  useRedirect,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import { Grid } from "@mui/material";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import { AdministrationServicePath, STRUCTURAL_UNITS } from "utils/constants";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import permissions from "app/permissions";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";

const EditGroupBlacklistCountries = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const canUpdate = checkPermission(getPermissions(), permissions.canUpdateGroupBlacklistCountriesInfo);

  const validateUniqueCountryPairs = value => {
    if (!Array.isArray(value)) return;
    const uniquePairs = new Set();

    for (const pair of value) {
      if (!pair?.countryOneId || !pair?.countryTwoId) continue;

      // Same country check
      if (pair.countryOneId === pair.countryTwoId) {
        return "Двете държави в двойката не могат да бъдат еднакви.";
      }

      // Normalize to detect reversed duplicates like (23,54) and (54,23)
      const key =
        pair.countryOneId < pair.countryTwoId
          ? `${pair.countryOneId}-${pair.countryTwoId}`
          : `${pair.countryTwoId}-${pair.countryOneId}`;

      if (uniquePairs.has(key)) {
        return "Съществува дублираща се двойка държави.";
      }

      uniquePairs.add(key);
    }

    return undefined;
  };

  const onSuccess = () => {
    notify(`Успешно редактиране на информация за вражески държави`, { type: "success" });
    redirect("/" + AdministrationServicePath + STRUCTURAL_UNITS);
  };

  return (
    <Edit
      title="Редакция на вражески държави"
      mutationMode="pessimistic"
      mutationOptions={{ onSuccess }}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={10}
          >
            <ArrayInput
              source="blacklistCountries"
              label=" "
              validate={validateUniqueCountryPairs}
            >
              <SimpleFormIterator
                disableAdd={!canUpdate}
                disableRemove={!canUpdate}
                disableReordering
                disableClear
                inline
                sx={settings.style.iteratorWithoutGap}
              >
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={12}
                    md={6}
                  >
                    <ReferenceInput
                      source="countryOneId"
                      reference={administrationRequests.getCountriesSelect()}
                    >
                      <AutocompleteInput
                        validate={[required()]}
                        label="Държава"
                        optionText="nameBg"
                        optionValue="id"
                        filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                      />
                    </ReferenceInput>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                  >
                    <ReferenceInput
                      source="countryTwoId"
                      reference={administrationRequests.getCountriesSelect()}
                    >
                      <AutocompleteInput
                        validate={[required()]}
                        label="Държава"
                        optionText="nameBg"
                        optionValue="id"
                        filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                      />
                    </ReferenceInput>
                  </Grid>
                </Grid>
              </SimpleFormIterator>
            </ArrayInput>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
export default EditGroupBlacklistCountries;
